import React from 'react';
import AppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Route } from '../../../types/types';
import CustomDrawer from './CustomDrawer';
import { Global } from '../../../../utils/global';

const theme = createTheme({
  components: {
    MuiDrawer: {
      styleOverrides: {
        paper: {
          background: Global.COLOR_STANDARD_BLUE,
          borderRight: 'none'
        }
      }
    }
  }
});

interface Props {
  routes: Route[];
  drawerWidth: number;
}

const CustomSidebar = ({ routes, drawerWidth }: Props) => {
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <ThemeProvider theme={theme}>
      <AppBar
        position='fixed'
        sx={{
          width: { md: `calc(100% - ${drawerWidth}px)` },
          ml: { md: `${drawerWidth}px` }
        }}
      >
        <Toolbar sx={{ display: { md: 'none' } }}>
          <IconButton
            color='inherit'
            aria-label='open drawer'
            edge='start'
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { md: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant='h6' noWrap component='div'>
            Medical Center
          </Typography>
        </Toolbar>
      </AppBar>
      <CustomDrawer
        routes={routes}
        drawerWidth={drawerWidth}
        mobileOpen={mobileOpen}
        onDrawerClicked={handleDrawerToggle}
      />
    </ThemeProvider>
  );
};

export default CustomSidebar;
